<template>
  <v-container style="padding-top: 0px; padding-bottom: 0px;">
    <v-layout>
      <v-flex>
        <div id="player"></div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "Player",
  data() {
    return {}
  },
  mounted() {
    window.jwplayer.key = "XKEzXKrNzEbdXMNJhH9GPlnJFZElaIME8FH5xozaTVc=";
    var jwconf = {
      playlist: [
        {
          image: '',
          sources: [{ file: 'https://wowzaprod163-i.akamaihd.net/hls/live/619812/fffe2b54/playlist.m3u8' }]
        }
      ],
      skin: "seven",
      title: 'Congreso de Urgencias',
      width: "100%",
      height: "auto",
      aspectratio: "21:9",
      autostart: false,
      stretching: "uniform",
      androidhls: true,
      hlshtml: true,
      analytics: {
        enabled: false,
        cookies: false
      },
      abouttext: "XEGMENTA HD STREAMING",
      aboutlink: "https://www.xegmenta.com"
    };
    window.jwplayer("player").setup(jwconf);
  }
};
</script>